import * as React from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface EmptyCardCta {
  label: string
  icon?: React.ReactNode
  onClick?: () => void
}

interface EmptyCardProps {
  icon: React.ReactNode
  title: string
  description?: string
  cta?: EmptyCardCta
  className?: string
}

const EmptyCard = ({ icon, title, description, cta, className }: EmptyCardProps) => {
  return (
    <Card className={cn('pt-0', className)}>
      <CardContent className="flex flex-1 flex-col items-center justify-center gap-4 px-10 py-20 text-center">
        <div
          className="flex size-10 items-center justify-center rounded-full"
          style={{ background: 'var(--brand-500)', color: 'var(--brand-800)' }}
        >
          {icon}
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="text-xl font-semibold text-foreground">{title}</div>
          {description && <div className="text-lg text-foreground">{description}</div>}
        </div>
        {cta && (
          <Button
            variant="outline"
            size="sm"
            onClick={cta.onClick}
            className="rounded-lg text-[15px] font-semibold leading-5"
          >
            {cta.icon}
            {cta.label}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}

export default EmptyCard
